import { farasod } from "./api"

const endpoint = "/wallet"

export const getMyWallet = async () => {
  const response = await farasod.get(`${endpoint}/my`)

  return response.data
}

export const getServiceOwnerWallet = async () => {
  const response = await farasod.get(`${endpoint}/serviceOwner`)

  return response.data
}

export const getBalanceReport = async () => {
  const response = await farasod.get(`${endpoint}/report/balance`)

  return response.data
}
